<ziro-fieldset-header [legend]="'tkey;shared.model.microsoft_teams_calling.ad_attributes.header'">
  @for (field of attributeFields(); track field) {
    <ziro-text [fieldId]="field" [hidden]="hiddenFields.includes(field)"></ziro-text>
  }
</ziro-fieldset-header>
